import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Aboutcard from "./AboutCard";
import Techstack from "./Techstack";
import Github from "./Github";
import Typewriter from "typewriter-effect";
import {
  AiFillGithub,
  AiOutlineMail,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function AboutMe() {
  return (
    <>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row className="align-items-center justify-content-center">
            <Col xs={12} md={6} className="home-header text-start">
              <h1 style={{ paddingBottom: "15px" }}>
                Hola! <span className="wave" role="img" aria-labelledby="wave">👋🏻</span>
              </h1>
              <h1 className="heading-name">
                Soy <strong className="purple">Lautaro Pena</strong>
              </h1>
              <div className="typing-wrapper">
                <Typewriter
                  options={{
                    strings: ["Full Stack Developer"],
                    autoStart: true,
                    loop: true,
                    delay: 80,
                    deleteSpeed: 50,
                  }}
                />
              </div>
              <div className="home-about-social" style={{ paddingTop: "20px" }}>
                <ul className="home-about-social-links">
                  <li className="social-icons">
                    <a
                      href="https://github.com/LautaroPena02"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="icon-colour home-social-icons"
                    >
                      <AiFillGithub />
                    </a>
                  </li>
                                    <li className="social-icons">
                    <a
                      href="https://www.linkedin.com/in/lautaropenadev/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="icon-colour home-social-icons"
                    >
                      <FaLinkedinIn />
                    </a>
                  </li>
                  <li className="social-icons">
                    <a
                      href="mailto:lautaropena99@gmail.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="icon-colour home-social-icons"
                    >
                      <AiOutlineMail />
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col xs={12} md={6} className="about-sidebar text-start">
              <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                Sobre <strong className="purple">Mí</strong>
              </h1>
              <Aboutcard />
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid className="about-section">
        <Container>
          <h1 className="project-heading">
            <strong className="purple">Habilidades</strong> Profesionales
          </h1>
          <Techstack />

          <Github />
        </Container>
      </Container>
    </>
  );
}

export default AboutMe;
